// react
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
// components
import LanguageDropdown from "../components/LanguageDropdown";
import NotificationDropdown from "../components/NotificationDropdown";
import ProfileDropdown from "../components/ProfileDropdown";
import TopbarSearch from "../components/TopbarSearch";
// images
import logoSmDark from "../assets/images/logo_sm_dark.png";
import logoSmLight from "../assets/images/logo_sm.png";
import logo from "../assets/images/logo-light.png";
import { API } from "aws-amplify";
//constants
import * as layoutConstants from "../constants/layout";
import * as subscriptions from "../graphql/subscriptions";
import * as queries from "../graphql/queries";
import * as customMutations from "./graphql/topbar.mutations";
import i18n from "i18next";

// get the profilemenu
const ProfileMenus = (userType, companyID) => [
  /*   {
    key: "contact",
    label: "Contact",
    icon: "mdi mdi-card-account-phone-outline",
    redirectTo: "/contact",
    restrictedTo: "",
  }, */
  {
    key: "settings",
    label: "Settings",
    icon: "mdi mdi-cogs",
    redirectTo: "/account",
    restrictedTo: "",
  },
  {
    key: "companySettings",
    label: "Company Settings",
    icon: "mdi mdi-office-building-outline",
    redirectTo:
      userType === "customer"
        ? "/companySettings/" + companyID
        : "/customer/" + companyID,
    restrictedTo: "customers.details.update",
  },
  {
    key: "supplierSettings",
    label: "Company Settings",
    icon: "mdi mdi-office-building-outline",
    redirectTo: "/supplierSettings/" + companyID,
    restrictedTo: "suppliers.details.update",
  },
  {
    key: "user-management",
    label: "User Management",
    icon: "mdi mdi-account-multiple-outline",
    redirectTo: "/users-management",
    restrictedTo: "users.read",
  },
  {
    key: "user-roles-management",
    label: "User Roles Management",
    icon: "mdi mdi-account-multiple-outline",
    redirectTo: "/userRolesManagement",
    restrictedTo: "userRoles.update",
  },
  {
    key: "import-values",
    label: "Import Values",
    icon: "mdi mdi-database-arrow-left-outline",
    redirectTo: "/importValues",
    restrictedTo: "userRoles.update",
  },
  {
    key: "logout",
    label: "Logout",
    icon: "mdi mdi-logout",
    redirectTo: "/logout",
    restrictedTo: "",
  },
];

const Topbar = ({
  hideLogo,
  navCssClasses,
  openLeftMenuCallBack,
  topbarDark,
}) => {
  // const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isopen, setIsopen] = useState(false);

  const [notifications, setNotifications] = useState([]);
  // const navbarCssClasses = navCssClasses || "";
  // const containerCssClasses = !hideLogo ? "container-fluid" : "";
  const { layoutType } = useSelector((state) => ({
    layoutType: state.Layout.layoutType,
  }));
  const { user } = useSelector((state) => ({
    user: state.Auth.user,
  }));
  const location = useLocation();

  const items = [
    {
      name: "Orders",
      icon: "uil-box",
      permission: user.permissions.includes("orders.read"),
    },
    {
      name: "Deliveries",
      icon: "mdi mdi-truck-outline",
      permission: user.permissions.includes("deliveries.read"),
    },
    {
      name: "Items",
      icon: "mdi mdi-dots-hexagon",
      permission: user.permissions.includes("items.read"),
    },
    {
      name: "Product Requests",
      icon: "mdi mdi-gamepad-circle-outline",
      permission: user.permissions.includes("productRequests.read"),
    },
    {
      name: "Requests",
      icon: "mdi mdi-arrange-send-to-back",
      permission: user.permissions.includes("customerRequests.read"),
    },
    {
      name: "Purchase Orders",
      icon: "uil-receipt",
      permission: user.permissions.includes("purchaseOrders.read"),
    },
    {
      name: "Seafreight",
      icon: "uil-ship",
      permission: user.permissions.includes("shipments.read"),
    },
    {
      name: "Customs",
      icon: "uil-bill",
      permission: user.permissions.includes("customs.read"),
    },
    {
      name: "Air Freight",
      icon: "uil-plane-fly",
      permission: user.permissions.includes("shipments.read"),
    },
    {
      name: "Companies",
      icon: "mdi  mdi-account-edit-outline",
      permission:
        user.permissions.includes("suppliers.read") ||
        user.permissions.includes("customers.read") ||
        user.permissions.includes("companies.read"),
    },
    {
      name: "Documents",
      icon: "mdi mdi-file-document-multiple-outline",
      permission:
        user.permissions.includes("document.items.read") &&
        user.permissions.includes("document.orders.read"),
    },
  ];

  const [selectedItem, setSelectedItem] = useState("Category");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const checkLastLogin = () => {
      const lastLogin = localStorage.getItem("lastLogin");
      if (lastLogin) {
        const lastLoginDate = new Date(lastLogin);
        const today = new Date();
        const diffTime = today - lastLoginDate;

        const diffhours = diffTime / (1000 * 60 * 60);
        if (diffhours >= 1) {
          console.log(diffhours + ">= 1");
          return true;
        }
      } else {
        return true;
      }
      return false;
    };
    if (user && checkLastLogin()) {
      API.graphql({
        query: customMutations.updateUsers,
        variables: {
          input: { id: user.id, lastLogin: new Date().toISOString() },
        },
      })
        .then((resolve) => {
          localStorage.setItem("lastLogin", new Date().toISOString());
          console.log("User updated: ", resolve);
        })
        .catch((error) => {
          console.log("User update error: ", error);
        });
    }
  }, [location.key]);
  useEffect(() => {
    if (user) {
      if (!localStorage.getItem("notification_sent")) {
        // read all existing notifications
        API.graphql({
          query: queries.notificationsByUser,
          variables: { userId: user.id, filter: { userRead: { eq: false } } },
        })
          .then((resolve) => {
            const notifications = resolve.data.notificationsByUser.items.map(
              (notification) => ({
                ...notification,
                reference: JSON.parse(notification.reference),
              })
            );

            setNotifications(notifications);

            // Check whether a new day has started
            if (notifications.length > 1 && checkAndUpdateDate()) {
              sendViewAllNotifications(notifications);
            }
          })
          .catch((error) => console.error("Notifications Error: ", error));

        // listen to new notifications
        API.graphql({
          query: subscriptions.onCreateNotifications,
          variables: {
            input: { userId: { eq: user.id } },
            filter: { userRead: { eq: false } },
          },
        }).subscribe({
          next: ({ provider, value }) => {
            let note = { ...value.data.onCreateNotifications };
            note.reference = JSON.parse(note.reference);
            setNotifications((notifications) => [...notifications, note]);

            // If no notification has been sent, send the notification
            if (!localStorage.getItem("notification_sent")) {
              sendNotification(note);
              localStorage.setItem("notification_sent", "true");

              // Remove the 'notification_sent' flag after sending the notification
              setTimeout(() => {
                localStorage.removeItem("notification_sent");
              }, 500);
            }
          },
        });

        //listen to read notifications and remove them from array
        API.graphql({
          query: subscriptions.onUpdateNotifications,
          variables: {
            input: { userId: { eq: user.id } },
          },
        }).subscribe({
          next: ({ provider, value }) => {
            let note = { ...value.data.onUpdateNotifications };
            if (note.userRead) {
              setNotifications((notifications) =>
                notifications.filter(
                  (notification) => note.id !== notification.id
                )
              );
            }
          },
        });
      }
    }
  }, [user]);

  const checkAndUpdateDate = () => {
    const now = new Date();
    const lastCheckedTimestamp = localStorage.getItem(
      "view_all_notifications_sent_timestamp"
    );

    if (
      !lastCheckedTimestamp ||
      now.getTime() - Number(lastCheckedTimestamp) >= 24 * 60 * 60 * 1000
    ) {
      // 24 hours have passed, so we set the date
      localStorage.setItem(
        "view_all_notifications_sent_timestamp",
        now.getTime().toString()
      );
      return true;
    }
    return false;
  };

  const sendViewAllNotifications = (notifications) => {
    const message =
      t("You have") +
      " " +
      notifications.length +
      " " +
      t("unread notifications.");
    const reference = {
      message: t("Click here to view all notifications"),
      url: "/notifications?messages=unread&page=1",
    };
    if (Notification.permission === "granted") {
      const notification = new Notification(message, {
        body: reference.message,
        icon: `${process.env.PUBLIC_URL}/favicon.ico`,
        data: { url: reference.url },
      });

      notification.onclick = (event) => {
        event.preventDefault();
        window.open(notification.data.url, "_blank");
      };
    }
  };

  const sendNotification = (note) => {
    if (Notification.permission === "granted") {
      const notification = new Notification(note.message, {
        body: note.reference.message,
        icon: `${process.env.PUBLIC_URL}/favicon.ico`,
        data: { url: note.reference.url, noteId: note.id },
      });

      notification.onclick = (event) => {
        event.preventDefault();
        window.open(notification.data.url, "_blank");
        markAsRead(notification.data.noteId);
      };
    } else if (Notification.permission === "default") {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          sendNotification(note);
        }
      });
    }
  };

  const markAsRead = (noteId) => {
    API.graphql({
      query: customMutations.updateNotifications,
      variables: {
        input: {
          id: noteId,
          userRead: true,
        },
      },
    })
      .then((response) => {
        console.log("response", response);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  /**
   * Toggle the leftmenu when having mobile screen
   */
  const handleLeftMenuCallBack = () => {
    setIsopen((prevState) => !prevState);
    if (openLeftMenuCallBack) openLeftMenuCallBack();
  };

  /**
   * Toggles the right sidebar
   */

  const clearNotificationHandler = async (ids) => {
    const promises = ids.map((id) => {
      return API.graphql({
        query: customMutations.updateNotifications,
        variables: { input: { id: id, userRead: "true" } },
      });
    });
    Promise.all(promises).then((_) => {
      setNotifications((notifications) => {
        let returnNotifications = [...notifications];
        returnNotifications = returnNotifications.filter(
          (notification) => !ids.includes(notification.id)
        );
        return returnNotifications;
      });
    });

    // ids.map((id, i) => {
    //   API.graphql({
    //     query: mutations.updateNotifications,
    //     variables: { input: { id: id, userRead: true } },
    //   }).then((_) => {
    //     // Find specific Notifcation in Array and remove it from the Array
    //     if (ids.length > 1 && i === ids.length - 1) {
    //       setNotifications([]);
    //     } else {
    //       const removeNotifications = notifications.filter(
    //         (notification) => notification.id !== id
    //       );
    //       setNotifications(removeNotifications);
    //     }
    //   });
    // });
  };

  return (
    <React.Fragment>
      <div
        className={
          "navbar-custom d-flex align-items-center justify-content-between"
        }
      >
        {!hideLogo && (
          <Link to="/" className="topnav-logo">
            <span className="topnav-logo-lg">
              <img src={logo} alt="logo" height="16" />
            </span>
            <span className="topnav-logo-sm">
              <img
                src={topbarDark ? logoSmLight : logoSmDark}
                alt="logo"
                height="16"
              />
            </span>
          </Link>
        )}

        <ul
          className="list-unstyled topbar-menu float-end mb-0 d-flex"
          style={{ order: "1" }}
        >
          {/* <li className="notification-list topbar-dropdown d-xl-none">
            <SearchDropdown />
          </li> */}
          <li className="dropdown notification-list topbar-dropdown d-none d-lg-block">
            <LanguageDropdown />
          </li>
          <li className="dropdown notification-list">
            <NotificationDropdown
              notifications={notifications}
              onClearNotification={clearNotificationHandler}
            />
          </li>

          <li className="dropdown notification-list">
            <ProfileDropdown
              menuItems={ProfileMenus(
                user && user.type,
                user && user.companyId
              )}
              username={user && `${user.firstName} ${user.lastName}`}
              firstName={user && user.firstName}
              lastName={user && user.lastName}
              userTitle={user && `${user.companyName}`}
            />
          </li>
        </ul>
        {/* toggle for vertical layout */}
        {layoutType === layoutConstants.LAYOUT_VERTICAL && (
          <button
            className="button-menu-mobile open-left disable-btn"
            onClick={handleLeftMenuCallBack}
          >
            <i className="mdi mdi-menu" />
          </button>
        )}

        {/* toggle for horizontal layout */}
        {layoutType === layoutConstants.LAYOUT_HORIZONTAL && (
          <Link
            to="#"
            className={classNames("navbar-toggle", { open: isopen })}
            onClick={handleLeftMenuCallBack}
          >
            <div className="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </Link>
        )}

        {/* toggle for detached layout */}
        {layoutType === layoutConstants.LAYOUT_DETACHED && (
          <Link
            to="#"
            className="button-menu-mobile disable-btn"
            onClick={handleLeftMenuCallBack}
          >
            <div className="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </Link>
        )}

        <TopbarSearch
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          loading={loading}
          setLoading={setLoading}
          items={items} /* items={SearchResults}  */
        />
      </div>
    </React.Fragment>
  );
};

export default Topbar;
